<template>
  <div>
    <div v-if="checkRolesByIds(['admin'])" class="vx-col w-full grid md:grid-cols-2 lg:grid-cols-2 mb-10 gap-5">
      <!-- <vx-card slot="no-body" class="text-center bg-primary-gradient greet-user">
        <img src="@/assets/images/elements/decore-left.png" class="decore-left" alt="Decore Left" width="200" />
        <img src="@/assets/images/elements/decore-right.png" class="decore-right" alt="Decore Right" width="175" />
        <feather-icon icon="AwardIcon" class="p-6 mb-8 bg-primary inline-flex rounded-full text-white shadow" svgClasses="h-8 w-8"></feather-icon>
        <h1 class="mb-6 text-white">Congratulations Karan,</h1>
        <p class="xl:w-3/4 lg:w-4/5 md:w-2/3 w-4/5 mx-auto text-white">You have done <strong>5</strong> more sales today. Check your new badge in your profile.</p>
      </vx-card> -->

      <vx-card title="Gurudwara Statistics" class="w-full sm:mt-0 md:mt-0 lg:mt-4">
        <div v-for="(browser, index) in browserStatistics" :key="browser.id" :class="{ 'mt-4': index }">
          <div class="flex justify-between">
            <div class="flex flex-col">
              <span class="mb-1">{{ browser.name }}</span>
              <h4>{{ browser.ratio }}</h4>
            </div>
            <div class="flex flex-col text-right">
              <span class="flex -mr-1">
                <span class="mr-1">{{ browser.comparedResult }}</span>
                <!-- <feather-icon
                  :icon="browser.comparedResult < 0 ? 'ArrowDownIcon' : 'ArrowUpIcon'"
                  :svgClasses="[browser.comparedResult < 0 ? 'text-danger' : 'text-success', 'stroke-current h-4 w-4 mb-1 mr-1']"
                ></feather-icon> -->
              </span>
              <!-- <span class="text-grey">{{ browser.time | time(true) }}</span> -->
            </div>
          </div>
          <vs-progress :percent="browser.ratio"></vs-progress>
        </div>
      </vx-card>

      <vx-card title="Overall Statistics" class="w-full sm:mt-0 md:mt-0 lg:mt-4">
        <div class="flex gap-3">
          <div class="task_card p-8 text-center w-full">
            <h4 class="font-semibold pb-2">{{ record.total_creators }}</h4>
            <p class="fn13">Total Creator</p>
          </div>
          <div class="task_card p-8 text-center w-full">
            <h4 class="font-semibold pb-2">{{ record.active_creators }}</h4>
            <p class="fn13">Active Creator</p>
          </div>
        </div>
        <div class="flex items-center mt-5 cursor-pointer" @click="$router.push({ name: 'audio-list' })">
          <feather-icon icon="MusicIcon" class="cursor-pointer mr-2 text-success"></feather-icon>
          <div class="leading-tight">
            <p class="font-medium">Total Audios</p>
          </div>
          <div class="ml-auto">
            <div class="flex items-center">
              <!-- <p class="text-xs">Days to left : 10</p> -->
              <vs-chip class="ml-2 mb-0 user_chip cursor-pointer">
                <p class="fn14 font-semibold">{{ record.active_creators }}</p>
              </vs-chip>
            </div>
          </div>
        </div>
        <div class="flex items-center mt-5 cursor-pointer" @click="$router.push({ name: 'playlist-list' })">
          <feather-icon icon="HeadphonesIcon" class="cursor-pointer mr-2 text-dark"></feather-icon>
          <div class="leading-tight">
            <p class="font-medium">Total Playlist</p>
          </div>
          <div class="ml-auto">
            <div class="flex items-center">
              <!-- <p class="text-xs">Days to left : 10</p> -->
              <vs-chip class="ml-2 mb-0 user_chip cursor-pointer">
                <p class="fn14 font-semibold">{{ record.total_playlists }}</p>
              </vs-chip>
            </div>
          </div>
        </div>
        <div class="flex items-center mt-5 cursor-pointer" @click="$router.push({ name: 'video-list' })">
          <feather-icon icon="YoutubeIcon" class="cursor-pointer mr-2 text-warning"></feather-icon>
          <div class="leading-tight">
            <p class="font-medium">Total Videos</p>
          </div>
          <div class="ml-auto">
            <div class="flex items-center">
              <!-- <p class="text-xs">Days to left : 10</p> -->
              <vs-chip class="ml-2 mb-0 user_chip cursor-pointer">
                <p class="fn14 font-semibold">{{ record.total_videos }}</p>
              </vs-chip>
            </div>
          </div>
        </div>
        <div class="flex items-center mt-5 cursor-pointer" @click="$router.push({ name: 'gurudwara-list' })">
          <feather-icon icon="HomeIcon" class="cursor-pointer mr-2 text-danger"></feather-icon>
          <div class="leading-tight">
            <p class="font-medium">Total Gurudwara</p>
          </div>
          <div class="ml-auto">
            <div class="flex items-center">
              <!-- <p class="text-xs">Days to left : 10</p> -->
              <vs-chip class="ml-2 mb-0 user_chip cursor-pointer">
                <p class="fn14 font-semibold">{{ record.total_gurudwara }}</p>
              </vs-chip>
            </div>
          </div>
        </div>
        <div class="flex items-center mt-5 cursor-pointer" @click="$router.push({ name: 'committee-list' })">
          <feather-icon icon="BriefcaseIcon" class="cursor-pointer mr-2 text-secondary"></feather-icon>
          <div class="leading-tight">
            <p class="font-medium">Total Committee</p>
          </div>
          <div class="ml-auto">
            <div class="flex items-center">
              <!-- <p class="text-xs">Days to left : 10</p> -->
              <vs-chip class="ml-2 mb-0 user_chip cursor-pointer">
                <p class="fn14 font-semibold">{{ record.total_committee }}</p>
              </vs-chip>
            </div>
          </div>
        </div>
        <div class="flex items-center mt-5 cursor-pointer" @click="$router.push({ name: 'user-list' })">
          <feather-icon icon="UsersIcon" class="cursor-pointer mr-2 text-secondary"></feather-icon>
          <div class="leading-tight">
            <p class="font-medium">Total Users</p>
          </div>
          <div class="ml-auto">
            <div class="flex items-center">
              <!-- <p class="text-xs">Days to left : 10</p> -->
              <vs-chip class="ml-2 mb-0 user_chip cursor-pointer">
                <p class="fn14 font-semibold">{{ record.total_users }}</p>
              </vs-chip>
            </div>
          </div>
        </div>
      </vx-card>

      <!-- <vx-card title="Subscriptions" class="w-4/12">
        <template slot="actions">
          <flat-pickr v-model="dateRange" :config="datePickerConfig" placeholder="Select Date" class="w-full" id="dateRange" name="dateRange" />
        </template>

        <div class="flex justify-between text-center mt-6" slot="no-body-bottom">
          <div class="w-1/2 border border-solid d-theme-border-grey-light border-r-0 border-b-0 border-l-0">
            <p class="mt-4 text-3xl font-semibold">{{ orderCountRecord.total_orders }}</p>
            <p class="mb-4">Total Subscription</p>
          </div>
          <div class="w-1/2 border border-solid d-theme-border-grey-light border-r-0 border-b-0">
            <p class="mt-4 text-3xl font-semibold">₹ {{ orderCountRecord.total_subscription_revenue / 100 }}</p>
            <p class="mb-4">Total Revenew</p>
          </div>
        </div>
      </vx-card> -->
    </div>
    <div v-if="checkPermissionSlug(['analytics_log_view'])" class="vx-col w-full mb-base flex gap-5">
      <!-- Analytics Dashboard Card -->
      <vx-card id="analytics-dashboard" title="Analytics Dashboard" class="w-full">
        <template slot="actions">
          <div class="analytics-toolbar flex flex-wrap">
            <vs-button icon-pack="feather" icon="icon-refresh-ccw" @click="refreshAnalyticsData" class="analytics-refresh-btn">Refresh</vs-button>
            <div class="analytics-datepicker">
              <flat-pickr v-model="analyticsDateRange" :config="datePickerConfig" placeholder="Select Date Range" class="w-full daterange-picker" @change="fetchAnalyticsData" />

              <feather-icon v-if="analyticsDateRange" icon="XIcon" svgClasses="h-6 w-6 text-danger" data-clear v-tooltip="'Clear'" @click="clearDateRange" />
            </div>
            <div class="user-input-container">
              <customUser-select-2
                class="w-full user-input"
                name="user"
                placeholder=" Select User"
                autocomplete
                :ssr="true"
                :multiple="false"
                data-vv-as="User"
                v-validate="'required'"
                action="common/getUsers"
                :viewRendered="false"
                :options="UserList"
                v-model="selectedUser"
                @input="onUserChange"
                ref="userSelect"
              />
              <feather-icon v-if="selectedUser" icon="XIcon" svgClasses="h-6 w-6 text-danger ml-2 user-input-clear" data-clear v-tooltip="'Clear'" @click="clearSelectedUser" />
            </div>
          </div>
        </template>

        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          <vx-card v-for="(item, index) in engagementAnalytics" :key="`${item.kind || 'analytics'}-${item.book_id || item.event}-${index}`" class="w-full cursor-pointer analytics-card" @click.native="showAnalyticsList(item)" :style="{ backgroundColor: isDark ? 'var(--content-dark-bg)' : '' }">
            <div class="text-center">
              <h3 class="mb-2">{{ getEventName(item.event) }}</h3>
              <h2>{{ item.count }}</h2>
            </div>
          </vx-card>
        </div>

      </vx-card>

      <!-- Analytics List Modal -->
      <vs-popup v-if="showAnalyticsModal" class="holamundo" title="Analytics Details" :active.sync="showAnalyticsModal" fullscreen>
        <div class="mb-4">
          <div class="flex flex-wrap items-center gap-8 mt-2 justify-between">
            <h4>{{ getEventName(selectedEvent) }} - Total: {{ analyticsListTotal || 0 }}</h4>
            <div class="flex items-center gap-4">
              <feather-icon icon="CalendarIcon" class="text-primary"></feather-icon>
              <span>Date Range: {{ formatDateRange(analyticsDateRange) }}</span>
            </div>

            <div class="flex items-center gap-4">
              <feather-icon icon="UserIcon" class="text-primary"></feather-icon>
              <div v-if="selectedUser" class="flex items-center gap-1">
                <img v-if="selectedUser.avatar" :src="selectedUser.avatar" class="w-12 h-12 rounded-full object-cover" alt="User avatar" />
                <div>
                  <p class="font-medium user-identity__name">{{ userFullName(selectedUser) }}</p>
                  <p class="user-identity__handle">{{ userHandle(selectedUser) }}</p>
                </div>
              </div>
              <span v-else>All Users</span>
            </div>
          </div>
        </div>

        <vs-table id="analytics-list" class="vs-con-loading__container" stripe :data="analyticsListRecords" :total="analyticsListFilteredCount" :max-items="length">
          <template slot="thead">
            <vs-th>Full Name</vs-th>
            <vs-th>Handle Name</vs-th>
            <vs-th v-if="isAnalyticsKind">Referral By</vs-th>
            <vs-th v-if="selectedKind == 'nitnem_streak'">Nitnem Days</vs-th>
            <vs-th v-if="selectedKind == 'weekly_streak'">Weeks Completed</vs-th>
            <vs-th v-if="showEventDetailColumn">{{ getDetailColumnName(selectedEvent) }}</vs-th>
            <vs-th v-if="selectedEvent == 'Gurudwara Page visit'">Address</vs-th>
            <vs-th v-if="isAnalyticsKind || selectedKind == 'unique_login'">City</vs-th>
            <vs-th v-if="isAnalyticsKind || selectedKind == 'unique_login'">State</vs-th>
            <vs-th v-if="isAnalyticsKind || selectedKind == 'unique_login'">Country</vs-th>
            <vs-th>{{ analyticsDateColumnLabel }}</vs-th>
          </template>

          <template slot-scope="{ data }">
            <vs-tr v-for="(item, index) in data" :key="index">
              <vs-td>
                <div v-if="item.user" class="user-identity">
                  <p class="user-identity__name">{{ userFullName(item.user) }}</p>
                </div>
                <div v-else>—</div>
              </vs-td>
              <vs-td>
                <p v-if="item.user" class="user-identity__handle">{{ userHandle(item.user) }}</p>
                <span v-else>—</span>
              </vs-td>
              <vs-td v-if="isAnalyticsKind">
                <div v-if="item.user && item.user.referrer" class="user-identity">
                  <p class="user-identity__name">{{ userFullName(item.user.referrer) }}</p>
                  <p class="user-identity__handle">{{ userHandle(item.user.referrer) }}</p>
                </div>
                <div v-else>—</div>
              </vs-td>
              <vs-td v-if="selectedKind == 'nitnem_streak'">
                {{ item.nitnem_days || 0 }}
              </vs-td>
              <vs-td v-if="selectedKind == 'weekly_streak'">
                {{ item.weeks_completed || 0 }}
              </vs-td>
              <vs-td v-if="showEventDetailColumn">
                {{ getEventDetail(item, selectedEvent) }}
              </vs-td>
              <vs-td v-if="selectedEvent == 'Gurudwara Page visit'">
                <div v-if="item.gurudwara">
                  <p>{{ item.gurudwara.address }}</p>
                  <small>{{ item.gurudwara.city.name }}, {{ item.gurudwara.state.name }}, {{ item.gurudwara.country.country_name }}</small>
                </div>
                <div v-else></div>
              </vs-td>
              <vs-td v-if="isAnalyticsKind || selectedKind == 'unique_login'">
                {{ item.city ? item.city.name : '-' }}
              </vs-td>
              <vs-td v-if="isAnalyticsKind || selectedKind == 'unique_login'">
                {{ item.state ? item.state.name : '-' }}
              </vs-td>
              <vs-td v-if="isAnalyticsKind || selectedKind == 'unique_login'">
                {{ item.country ? item.country.country_name : '-' }}
              </vs-td>
              <vs-td>
                {{ formatAnalyticsDate(item.date) }}
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>

        <div class="flex justify-between mt-4" v-if="totalPages > 1">
          <vs-pagination v-model="page" :total="totalPages" :max="totalPages / length > 7 ? 7 : 5" class="mt-8"></vs-pagination>
        </div>
      </vs-popup>
    </div>
    <div v-if="checkPermissionSlug(['analytics_log_view'])" class="vx-col w-full mb-base flex gap-5">
      <!-- <vx-card id="analytics-dashboard" title="Platform Fees" class="w-full">
        <div class="vx-col flex items-center gap-10">
          <vs-input type="number" min="0" v-model.number="platForm_fee" placeholder="Enter PlatForm Fees" class="w-full" />
          <vs-button  @click="save_changes" class="mr-2">Update</vs-button>    
        </div>
      </vx-card> -->
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import 'flatpickr/dist/flatpickr.css'
import flatPickr from 'vue-flatpickr-component'
import VueApexCharts from 'vue-apexcharts'
import { mapGetters, mapState, mapActions } from 'vuex'
import CustomUserSelect2 from '@/components/custom/form-elements/CustomUserSelect2.vue'
import { dateMixins } from '@/mixins/dateMixins.js'

export default {
  mixins: [dateMixins],

  components: {
    VueApexCharts,
    flatPickr,
    CustomUserSelect2
  },
  data() {
    return {
      page: 1,
      length: 100,
      analyticsDateRange: null,
      showAnalyticsModal: false,
      selectedEvent: '',
      selectedKind: 'analytics',
      selectedBookId: null,
      analyticsData: [],
      dateRange: null,
      UserList: [],
      selectedUser: null,
      datePickerConfig: {
        wrap: true,
        mode: 'range', // Enables date range selection
        dateFormat: 'd-m-Y',
        maxDate: new Date()
      },
      platForm_fee:0,
      engagementCardDefs: [
        { event: 'User Active', kind: 'analytics' },
        { event: 'Users Logged In', kind: 'unique_login' },
        { event: 'Path Read', kind: 'analytics' },
        { event: 'Listen Audio', kind: 'analytics' },
        { event: 'Watch Video', kind: 'analytics' },
        { event: 'Gurudwara Page visit', kind: 'analytics' },
        { event: 'Organization Page visit', kind: 'analytics' }
      ],
      streakCardDefs: [
        { event: 'Nitnem Streaks Completed', kind: 'nitnem_streak' },
        { event: 'Satguru Prasadi Weekly Streak', kind: 'weekly_streak', match: /satguru/i },
        { event: 'Anand Sahib Weekly Streak', kind: 'weekly_streak', match: /anand/i },
        { event: 'Japji Sahib Weekly Streak', kind: 'weekly_streak', match: /japji/i },
        { event: 'Jaap Sahib Weekly Streak', kind: 'weekly_streak', match: /jaap(?!ji)/i },
        { event: 'Tav Prasad Savaiye Weekly Streak', kind: 'weekly_streak', match: /tav|savaiye/i },
        { event: 'Chaupai Sahib Weekly Streak', kind: 'weekly_streak', match: /chaupai/i },
        { event: 'Rehraas Sahib Weekly Streak', kind: 'weekly_streak', match: /rehraas|rehras/i },
        { event: 'Kirtan Sohila Weekly Streak', kind: 'weekly_streak', match: /kirtan|sohila/i }
      ],
      goalOverviewRadialBar: {
        // series: [83],
        chartOptions: {
          plotOptions: {
            radialBar: {
              size: 110,
              startAngle: -150,
              endAngle: 150,
              hollow: {
                size: '77%'
              },
              track: {
                background: '#bfc5cc',
                strokeWidth: '50%'
              },
              dataLabels: {
                name: {
                  show: false
                },
                value: {
                  offsetY: 18,
                  color: '#99a2ac',
                  fontSize: '4rem'
                }
              }
            }
          },
          colors: ['#00db89'],
          fill: {
            type: 'gradient',
            gradient: {
              shade: 'dark',
              type: 'horizontal',
              shadeIntensity: 0.5,
              gradientToColors: ['#00b5b5'],
              inverseColors: true,
              opacityFrom: 1,
              opacityTo: 1,
              stops: [0, 100]
            }
          },
          stroke: {
            lineCap: 'round'
          },
          chart: {
            sparkline: {
              enabled: true
            },
            dropShadow: {
              enabled: true,
              blur: 3,
              left: 1,
              top: 1,
              opacity: 0.1
            }
          }
        }
      },
      goalOverview: {
        analyticsData: {
          completed: 786617,
          inProgress: 13561
        },
        series: [83]
      }
    }
  },

  /** Import State */
  computed: {
    ...mapState('permission', ['permissions']),
    ...mapState('auth', ['roles']),
    ...mapState('dashboard', ['record', 'orderCountRecord', 'analyticsCounts', 'analyticsListRecords', 'analyticsListTotal', 'analyticsListFilteredCount', 'analyticsLoading', 'analyticsListLoading']),
    ...mapGetters('auth', ['checkRolesByIds', 'checkPermissionSlug']),
    isDark() {
      return this.$store.state.theme === 'dark'
    },
    engagementAnalytics() {
      const rows = this.analyticsData || []
      return this.engagementCardDefs.map((card) => {
        const found = rows.find((item) => item && item.kind === card.kind && item.event === card.event)
        return {
          ...card,
          count: found && found.count != null ? found.count : 0,
          book_id: found ? found.book_id : undefined
        }
      })
    },
    streakAnalytics() {
      const rows = this.analyticsData || []
      const used = new Set()
      return this.streakCardDefs.map((card) => {
        let found = null
        if (card.kind === 'nitnem_streak') {
          found = rows.find((item) => item && item.kind === 'nitnem_streak')
        } else {
          found = rows.find((item, index) => {
            if (!item || item.kind !== 'weekly_streak' || used.has(index)) return false
            const label = `${item.event || ''} ${item.book_name || ''}`
            return card.match.test(label)
          })
          if (found) used.add(rows.indexOf(found))
        }
        return {
          event: card.event,
          kind: card.kind,
          count: found && found.count != null ? found.count : 0,
          book_id: found ? found.book_id : undefined
        }
      })
    },
    isAnalyticsKind() {
      return this.selectedKind === 'analytics'
    },
    showEventDetailColumn() {
      return this.isAnalyticsKind && this.selectedEvent !== 'User Active'
    },
    analyticsDateColumnLabel() {
      if (this.selectedKind === 'unique_login') return 'Last Login'
      if (this.selectedKind === 'nitnem_streak') return 'Last Completed Day'
      if (this.selectedKind === 'weekly_streak') return 'Last Completed Week'
      return 'Date'
    },
    totalPages() {
      return Math.ceil(this.analyticsListFilteredCount / this.length)
    },

    browserStatistics() {
      return [
        {
          id: 1,
          name: 'Invitation Pending',
          ratio: this.record.pending_invitations
        },
        {
          id: 3,
          name: 'Individual Invited ',
          ratio: this.record.individual_invited
        },
        {
          id: 2,
          name: 'Committee Invited',
          ratio: this.record.committee_invited
        },
        {
          id: 4,
          name: 'Accepted Invitation',
          ratio: this.record.accepted_invitations
        }
      ]
    }
  },
  methods: {
    ...mapActions('dashboard', {
      counts: 'counts',
      orderCounts: 'orderCounts',
      fetchAnalyticsCounts: 'analyticsCounts',
      fetchAnalyticsList: 'analyticsList'
    }),
    ...mapActions('common', {
      getUsers: 'getUsers'
    }),
    onHeaderRefresh() {
      this.counts()
      this.getOrderCounts()
      this.fetchAnalyticsData()
    },
    async refreshAnalyticsData() {
      try {
        // Show loading indicator
        this.$vs.loading({
          container: '#analytics-dashboard',
          scale: 0.6
        })

        // Reset to first page
        this.page = 1

        // Fetch fresh data
        await Promise.all([
          this.fetchAnalyticsData(),
          this.$store.dispatch('adminNotifications/refresh').catch(() => {})
        ])

        this.$vs.notify({
          title: 'Success',
          text: 'Data refreshed successfully',
          color: 'success',
          iconPack: 'feather',
          icon: 'icon-check'
        })
      } catch (error) {
        console.error('Refresh error:', error)
        this.$vs.notify({
          title: 'Error',
          text: 'Failed to refresh data',
          color: 'danger',
          iconPack: 'feather',
          icon: 'icon-alert-circle'
        })
      } finally {
        this.$vs.loading.close('#analytics-dashboard > .con-vs-loading')
      }
    },
    async loadPlatformFee() {
      try {
        const res = await this.$http.get('admin/platform-fee/details')
        const data = (res && res.data && res.data.data) || {}
        const value =
          data.platForm_fee != null ? data.platForm_fee : null
        if (value != null) this.platForm_fee = Number(value)
      } catch (error) {
        // Platform fee UI is currently hidden; do not surface this error
      }
    },
    async save_changes() {
      const feeValue = Number(this.platForm_fee)
      if (Number.isNaN(feeValue) || feeValue < 0) {
        this.$vs.notify({ title: 'Invalid value', text: 'Please enter a valid non-negative number', color: 'warning', position: 'top-center', time: 2200 })
        return
      }
      this.$vs.dialog({
        type: 'confirm',
        color: 'primary',
        title: 'Confirm change',
        text: `Are you sure you want to change the platform fee to ₹ ${feeValue}?`,
        acceptText: 'Yes, update',
        cancelText: 'Cancel',
        accept: async () => {
          try {
            const res = await this.$http.post('admin/platform-fee/create-update', { platForm_fee: feeValue })
            const message = (res && res.data && res.data.message) || 'Platform fee updated'
            this.$vs.notify({ title: 'Success', text: message, color: 'success', position: 'top-center', time: 2000 })
            await this.loadPlatformFee()
          } catch (error) {
            const message = (error && error.message) || 'Failed to update platform fee'
            this.$vs.notify({ title: 'Error', text: message, color: 'danger', position: 'top-center', time: 2800 })
          }
        }
      })
    },
    clearSelectedUser() {
      // Clear the selected user
      this.selectedUser = null

      // Directly reset the select component
      if (this.$refs.userSelect) {
        // Additional reset if needed
        if (this.$refs.userSelect.$refs.selectBox) {
          this.$refs.userSelect.$refs.selectBox.$refs.inputselect.value = ''
          this.$refs.userSelect.$refs.selectBox.valuex = ''
        }
      }
      // Reset and fetch data
      this.page = 1
      this.fetchAnalyticsData()
    },
    onUserChange(user) {
      this.page = 1
      this.fetchAnalyticsData()
    },

    formatDateRange(range) {
      if (!range || !range.length) return 'All time'
      const dateRangeArray = range.split(' to ')

      // Adjust parsing to match the new format 'DD-MM-YYYY'
      const from = dateRangeArray[0] // Set to start of day in UTC
      const to = dateRangeArray[1]
        ? dateRangeArray[1] // Set to end of day in UTC
        : null

      return `${from} ${to ? `- ${to}` : ''}`
    },
    getAnalyticsDateParams() {
      let startDate = null
      let endDate = null
      let fromCalendar = null
      let toCalendar = null
      if (this.analyticsDateRange) {
        const dateRangeArray = this.analyticsDateRange.split(' to ')
        fromCalendar = moment(dateRangeArray[0], 'DD-MM-YYYY').format('YYYY-MM-DD')
        toCalendar = dateRangeArray[1]
          ? moment(dateRangeArray[1], 'DD-MM-YYYY').format('YYYY-MM-DD')
          : fromCalendar
        startDate = moment(dateRangeArray[0], 'DD-MM-YYYY').startOf('day').utc()
        endDate = dateRangeArray[1]
          ? moment(dateRangeArray[1], 'DD-MM-YYYY').endOf('day').utc()
          : moment(dateRangeArray[0], 'DD-MM-YYYY').endOf('day').utc()
      }
      return {
        from_date: startDate ? startDate.toISOString() : null,
        to_date: endDate ? endDate.toISOString() : null,
        from_calendar: fromCalendar,
        to_calendar: toCalendar,
        user: this.selectedUser ? this.selectedUser.value : null
      }
    },
    async fetchAnalyticsData() {
      await this.fetchAnalyticsCounts(this.getAnalyticsDateParams())
      this.analyticsData = this.analyticsCounts
    },
    async showAnalyticsList(item) {
      this.selectedEvent = item.event
      this.selectedKind = item.kind || 'analytics'
      this.selectedBookId = item.book_id || null
      this.page = 1
      await this.fetchAnalyticsListData()
      this.showAnalyticsModal = true
    },

    async fetchAnalyticsListData() {
      const params = {
        ...this.getAnalyticsDateParams(),
        event: this.selectedKind === 'analytics' ? this.selectedEvent : undefined,
        kind: this.selectedKind || 'analytics',
        book_id: this.selectedBookId || undefined,
        page: this.page,
        limit: this.length
      }
      await this.fetchAnalyticsList(params)
    },
    getOrderCounts() {
      let startDate = null
      let endDate = null
      if (this.dateRange) {
        const dateRangeArray = this.dateRange.split(' to ')

        // Adjust parsing to match the new format 'DD-MM-YYYY'
        startDate = moment(dateRangeArray[0], 'DD-MM-YYYY').startOf('day').utc() // Set to start of day in UTC
        endDate = dateRangeArray[1]
          ? moment(dateRangeArray[1], 'DD-MM-YYYY').endOf('day').utc() // Set to end of day in UTC
          : moment(dateRangeArray[0], 'DD-MM-YYYY').endOf('day').utc()
      }

      this.orderCounts({
        start_date: startDate ? startDate.toISOString() : null, // Send as ISO string in UTC
        end_date: endDate ? endDate.toISOString() : null // Send as ISO string in UTC
      })
    },
    clearDateRange() {
      this.analyticsDateRange = null // Clear the dateRange value
      this.fetchAnalyticsData() // Optionally call your data fetch function to reset the data
    },
    getDetailColumnName(event) {
      switch (event) {
      case 'Listen Audio':
        return 'Audio'
      case 'Watch Video':
        return 'Video'
      case 'Path Read':
        return 'Book'
      case 'Gurudwara Page visit':
        return 'Gurudwara'
      case 'Organization Page visit':
        return 'Organization'
      default:
        return 'Details'
      }
    },

    isStreakMetric(item) {
      if (!item) return false
      const kind = String(item.kind || '').toLowerCase()
      const event = String(item.event || '').toLowerCase()
      return kind.includes('streak') || event.includes('streak')
    },
    getEventName(event) {
      switch (event) {
      case 'User Active':
        return 'Users Active'
      case 'Users Logged In':
        return 'Users Logged In'
      case 'Listen Audio':
        return 'Listening To Audios'
      case 'Watch Video':
        return 'Watching Videos'
      case 'Path Read':
        return 'Reading Path'
      case 'Gurudwara Page visit':
        return 'Visiting Gurudwara Pages'
      case 'Organization Page visit':
        return 'Visiting Organization Pages'
      default:
        return event || 'Unknown'
      }
    },

    getEventDetail(item, event) {
      switch (event) {
      case 'Listen Audio':
        return item.audio ? item.audio.title : '-'
      case 'Watch Video':
        return item.video ? item.video.title : '-'
      case 'Path Read':
        return item.book ? item.book.title : '-'
      case 'Gurudwara Page visit':
        return item.gurudwara ? item.gurudwara.name : '-'
      case 'Organization Page visit':
        return item.organization ? item.organization.name : '-'
      default:
        return '-'
      }
    },
    userFullName(user) {
      if (!user) return 'Unknown user'
      const fullName = `${user.first_name || ''} ${user.last_name || ''}`.trim()
      if (fullName) return fullName
      if (user.label) return String(user.label).replace(/\s*\(@?[^)]+\)\s*$/, '').trim() || user.label
      return user.handle_name || user.email || 'Unknown user'
    },
    userHandle(user) {
      if (!user || !user.handle_name) return '—'
      return user.handle_name.startsWith('@') ? user.handle_name : `@${user.handle_name}`
    },
    formatAnalyticsDate(date) {
      if (!date) return '—'
      const value = String(date)
      if (/^\d{4}-\d{2}-\d{2}$/.test(value)) {
        return moment(value, 'YYYY-MM-DD').format('DD-MM-YYYY')
      }
      return this.formatLocalDateTime(date)
    }
  },

  /** On Rendering */
  async mounted() {
    this.counts()
    this.getOrderCounts()
    this.fetchAnalyticsData()

    if (this.$store.state.auth.userInfo.role.slug === 'hotel-manager') {
      this.$router.push('/hotel-dashboard')
    }

    const userResult = await this.getUsers({ page: 1, limit: 300000, type: 'dropdown' })
    this.UserList = userResult.data
    this.$root.$on('admin-header-refresh', this.onHeaderRefresh)
  },
  beforeDestroy() {
    this.$root.$off('admin-header-refresh', this.onHeaderRefresh)
  },
  /** Watchers */
  watch: {
    dateRange() {
      this.getOrderCounts()
    },
    analyticsDateRange() {
      this.page = 1
      this.fetchAnalyticsData()
    },
    page() {
      this.fetchAnalyticsListData()
    },
    analyticsListLoading() {
      if (this.analyticsListLoading) {
        this.$vs.loading({
          container: '#analytics-list',
          scale: 0.45
        })
      } else {
        this.$vs.loading.close('#analytics-list > .con-vs-loading')
      }
    }
  }
}
</script>
<style lang="scss">
.analytics-card {
  transition: all 0.3s ease;
  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
  }
}
.user-identity {
  line-height: 1.3;
}
.user-identity__name {
  font-weight: 600;
  color: inherit;
  margin: 0;
}
.user-identity__handle {
  font-size: 0.85rem;
  color: #4b5563;
  margin: 0;
}
.theme-dark .user-identity__handle {
  color: #d1d5db;
}

.project_card {
  overflow: auto;
  padding-bottom: 1rem;
  .vx-card__header {
    padding: 1.5rem 1.5rem 0.5rem;
  }
  .vx-card__body {
    padding: 1rem 1rem 0 1.5rem !important;
    max-height: 280px;
    overflow: auto;
  }
}

.analytics-toolbar {
  align-items: center;
  gap: 12px;
}

.analytics-toolbar .analytics-refresh-btn {
  margin: 0 !important;
  height: 48px !important;
  min-height: 48px !important;
  padding: 0 16px !important;
  box-sizing: border-box;
}

.analytics-datepicker {
  position: relative;
}

.analytics-datepicker .feather-icon {
  position: absolute;
  top: 50%;
  right: 12px;
  transform: translateY(-50%);
  cursor: pointer;
}

.analytics-datepicker .flatpickr-input,
.analytics-datepicker input.flatpickr-input {
  height: 48px !important;
  min-height: 48px !important;
  padding: 0 12px !important;
  box-sizing: border-box;
}

.daterange-picker {
  width: 400px !important;
}
@media only screen and (max-width: 480px) {
  .daterange-picker {
    width: 100% !important;
  }
}
.user-input-container {
  display: flex;
  align-items: center;
  position: relative;
  width: 400px;
}

.user-input-container .vs-select--input,
.user-input-container input.vs-select--input {
  height: 48px !important;
  min-height: 48px !important;
  box-sizing: border-box;
}

.user-input-container .feather-icon {
  position: absolute;
  right: 10%;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  z-index: 10;
}

.user-input {
  .vs__clear {
    display: none; /* Hide the default clear icon if present */
  }
}

.analytics-streaks-section {
  margin-top: 8px;
}

.analytics-section-divider {
  display: flex;
  align-items: center;
  gap: 16px;
  margin: 28px 0 16px;
}

.analytics-section-divider::before,
.analytics-section-divider::after {
  content: '';
  flex: 1;
  height: 1px;
  background: var(--divider, #d1d5db);
}

.analytics-section-title {
  font-size: 15px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  white-space: nowrap;
  color: var(--text-primary, #111);
}

.vx-card__actions {
  padding: 0.5rem 1.5rem;
  width: 100%;
}
</style>
